import BaseObjectDirective from './BaseObjectDirective';

/**
 * PartialObjectDirective is a subclass of BaseObjectDirective that provides a directive for rendering partial objects.
 * It uses AngularJS's $compile service and other dependencies to configure and render the directive.
 */
export class PartialObjectDirective extends BaseObjectDirective {
    /**
     * Constructs a new PartialObjectDirective instance.
     * @param {Object} $compile - AngularJS $compile service.
     * @param {Object} $bridges - AngularJS $bridges service.
     * @param {Object} $config - AngularJS $config service.
     * @param {Object} TaskDataService - TaskDataService instance.
     */
    constructor($injector, $scope, $compile, $bridges, $config, TaskDataService) {
        super($injector, $scope);
        this._logIdentifier = 'PartialObjectDirective';
        this.$compile = $compile;
        this.$bridges = $bridges;
        this.$config = $config;
        this.TaskDataService = TaskDataService;
    }

    /**
     * Returns the directive definition object for the PartialObjectDirective.
     * @returns {Object} The directive definition object.
     */
    get directive() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            template: "<div class='partialObject'><!--{{contentObject.getObjectData()}} -- {{partialPath}}--><ng-include src='partialPath'></div>",
            controller: ($scope) => {
                const partialUrlPrefix = this.$config.getTaskContentFolderPath();
                $scope.partialPath = partialUrlPrefix + $scope.contentObject.getObjectData().partialPath;
            }
        };
    }
}

// SMELL: This static property is not necessary if the dependency array is directly used in the registration function.
PartialObjectDirective.$inject = ['$compile', '$bridges', '$config', 'TaskDataService'];

/**
 * Registers the PartialObjectDirective with the given AngularJS module.
 * @param {Object} module - The AngularJS module to register the directive with.
 */
export default function registerPartialObjectDirective(module) {
    module.directive('asfPartialObject', ['$compile', '$bridges', '$config', 'TaskDataService', (...args) => new PartialObjectDirective(...args).directive]);
}